const CustomHiddenInputs = ({ values }) => {
  const [
    utmSource,
    utmMedium,
    utmCampaign,
    utmContent,
    utmTerm,
    hsaAd,
    hsaGrp,
    hsaCam,
    hsaSrc,
    origemLancamento,
    campanhaLancamento,
    emailIndicador,
    nomeIndicador,
    indicator,
    referral,
    recommendationId,
  ] = values;

  return (
    <>
      <div>
        <input type="hidden" name="field[1]" defaultValue={utmSource} />
      </div>
      <div>
        <input type="hidden" name="field[3]" defaultValue={utmCampaign} />
      </div>
      <div>
        <input type="hidden" name="field[4]" defaultValue={utmMedium} />
      </div>
      <div>
        <input type="hidden" name="field[90]" defaultValue={utmContent} />
      </div>

      <div>
        <input type="hidden" name="field[8]" defaultValue={hsaAd} />
      </div>
      <div>
        <input type="hidden" name="field[9]" defaultValue={hsaGrp} />
      </div>
      <div>
        <input type="hidden" name="field[10]" defaultValue={hsaCam} />
      </div>
      <div>
        <input type="hidden" name="field[11]" defaultValue={hsaSrc} />
      </div>
      <div>
        <input type="hidden" name="field[64]" defaultValue={origemLancamento} />
      </div>
      <div>
        <input
          type="hidden"
          name="field[65]"
          defaultValue={campanhaLancamento}
        />
      </div>
      <div>
        <input type="hidden" name="field[68]" defaultValue={emailIndicador} />
      </div>
      <div>
        <input type="hidden" name="field[69]" defaultValue={nomeIndicador} />
      </div>
      <div>
        <input type="hidden" name="field[180]" defaultValue={indicator} />
      </div>
      <div>
        <input type="hidden" name="field[181]" defaultValue={referral} />
      </div>
      <div>
        <input
          type="hidden"
          name="field[182]"
          defaultValue={recommendationId}
        />
      </div>
      <div>
        <input type="hidden" name="field[191]" defaultValue={utmTerm} />
      </div>
    </>
  );
};

export default CustomHiddenInputs;
